import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentUser: null,
  profile: null,
  loading: false,
  error: null
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    fetchUserStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchUserSuccess: (state, action) => {
      state.loading = false;
      state.currentUser = action.payload;
      state.error = null;
    },
    fetchUserFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchProfileStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchProfileSuccess: (state, action) => {
      state.loading = false;
      state.profile = action.payload;
      state.error = null;
    },
    fetchProfileFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearUser: (state) => {
      state.currentUser = null;
      state.profile = null;
      state.error = null;
    }
  }
});

export const {
  fetchUserStart,
  fetchUserSuccess,
  fetchUserFailure,
  fetchProfileStart,
  fetchProfileSuccess,
  fetchProfileFailure,
  clearUser
} = userSlice.actions;

export default userSlice.reducer; 